import { httpsCallable } from 'firebase/functions';
import firebaseConfig from '../../config';

const { databaseId } = firebaseConfig;

function EmailsFactory(firebase) {
  const sendReplyNotification = async ({ parentCommenterUID, emailData }) => {
    const sendReplyNotificationCallable = httpsCallable(
      firebase.functions,
      'emails-send-replyNotification'
    );
    return sendReplyNotificationCallable({
      parentCommenterUID,
      emailData,
      databaseId
    });
  };

  const sendMentionNotifications = async ({ mentionedUIDs, emailData }) => {
    const sendMentionNotificationsCallable = httpsCallable(
      firebase.functions,
      'emails-send-mentionNotifications'
    );
    return sendMentionNotificationsCallable({
      mentionedUIDs,
      emailData,
      databaseId
    });
  };

  const sendReminder = async ({ users, templateAlias, emailData }) => {
    const sendReminderCallable = httpsCallable(
      firebase.functions,
      'emails-send-reminder'
    );
    return sendReminderCallable({
      users,
      templateAlias,
      emailData,
      databaseId
    });
  };

  const sendNewQuestionReleased = async ({
    users,
    templateAlias,
    emailData
  }) => {
    const sendNewQuestionReleasedCallable = httpsCallable(
      firebase.functions,
      'emails-send-newQuestionReleased'
    );
    return sendNewQuestionReleasedCallable({
      users,
      templateAlias,
      emailData,
      databaseId
    });
  };

  const sendMagicLink = async ({
    email,
    sessionId,
    origin,
    href,
    emailData
  }) => {
    const sendMagicLinkCallable = httpsCallable(
      firebase.functions,
      'emails-send-magicLink'
    );
    return sendMagicLinkCallable({
      email,
      sessionId,
      origin,
      href,
      emailData,
      databaseId
    });
  };

  return {
    sendReplyNotification,
    sendMentionNotifications,
    sendReminder,
    sendMagicLink,
    sendNewQuestionReleased
  };
}

export default EmailsFactory;
